import { Injectable } from '@angular/core';
import { Action, NgxsAfterBootstrap, NgxsOnInit, State, StateContext, Store } from '@ngxs/store';
import { LanguageService } from 'src/app/services/general/language/language.service';
import { CustomerService } from 'src/app/services/login.service';
import { LanguageListStateModel, LanguageStateModel } from './language-state.model';
import { GetLanguages } from './language.action';

// @State<LanguageStateModel>({
//   name: 'language',
//   defaults: {
//     Title :'',
//     Code:'',
//     Direction:'ltr',
//     Icon:'',
//     IsActive:true,
//     Primary:true
//   }
// })
@State<LanguageListStateModel>({
  name: 'LanguageList',
  defaults: {
    LanguageList:[]
  }
})
@Injectable()
export class LanguageState  implements NgxsOnInit ,NgxsAfterBootstrap {
  constructor(private languageService:LanguageService,private customerService:CustomerService){}
  ngxsAfterBootstrap(ctx: StateContext<LanguageListStateModel>): void {
    if(this.customerService.isLogged){
      ctx.dispatch(new GetLanguages())
    }  
  }
  ngxsOnInit(ctx: StateContext<LanguageListStateModel>): void {
   
  }

  @Action(GetLanguages)
  GetLanguages(ctx: StateContext<LanguageListStateModel>){
    return this.languageService.Get('').subscribe({
      next(value) {
        if(value.body.succeeded){
          const state = ctx.getState();
          ctx.setState({
            ...state,
            LanguageList: [value.body.data]
          });
          console.log(ctx.getState())
        }
      },
    })
  }
}